import styled from 'styled-components';

import { Stack } from '@mui/system';
import React from 'react';
import Box from '@mui/material/Box';

const StyledTable = styled.table<{ $bottomBorder?: boolean }>`
  width: 100%;
  border-bottom: ${props => props.$bottomBorder && '1px solid #d5d9e2'};
`;

const TableCell = styled.td`
  padding: 0.25em;
`;
const TableRow = styled.tr``;

type IDataSource = { labelIcon?: React.ReactElement; label: string; value: string | React.ReactNode }[];

export const DescriptionTable = ({
  dataSource,
  fontSize = '0.85rem',
  $bottomBorder,
}: {
  dataSource: IDataSource;
  fontSize?: string;
  $bottomBorder?: boolean;
}) => {
  return (
    <StyledTable $bottomBorder={$bottomBorder}>
      <tbody>
        {dataSource.map(({ labelIcon, label, value }) => (
          <TableRow key={label}>
            <TableCell
              style={{
                fontSize: fontSize,
              }}
            >
              <Stack flexDirection='row' alignItems='center' gap={1}>
                {labelIcon}
                {label}
              </Stack>
            </TableCell>
            <TableCell
              style={{
                fontSize: fontSize,
                color: 'black',
              }}
            >
              {value}
            </TableCell>
          </TableRow>
        ))}
      </tbody>
    </StyledTable>
  );
};
